(function () {
    const SECTION_SELECTOR = '[data-mb-policies]';
    const ITEM_SELECTOR = '[data-mb-policy-item]';
    const HEADER_SELECTOR = '[data-mb-policy-toggle]';
    const CONTENT_SELECTOR = '[data-mb-policy-content]';
    const LANG_BTN_SELECTOR = '[data-mb-policy-lang]';
    const LANG_LIST_SELECTOR = '.mb-policies__languages';

    function initPolicies(root) {
        const items = root.querySelectorAll(ITEM_SELECTOR);
        const langBtns = root.querySelectorAll(LANG_BTN_SELECTOR);

        /* ── Accordion toggle ── */
        items.forEach(function (item) {
            const header = item.querySelector(HEADER_SELECTOR);
            const content = item.querySelector(CONTENT_SELECTOR);
            if (!header || !content) return;

            header.addEventListener('click', function () {
                toggleItem(item, content);
            });
        });

        /* ── Language switcher ── */
        langBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var lang = btn.getAttribute('data-mb-policy-lang');
                setActiveLang(root, lang);
            });
        });

        /* ── Handle anchor on load & hashchange ── */
        handleHash(root);
        window.addEventListener('hashchange', function () {
            handleHash(root);
        });
    }

    function toggleItem(item, content) {
        var expanded = item.getAttribute('aria-expanded') === 'true';
        if (expanded) {
            collapseItem(item, content);
        } else {
            expandItem(item, content);
        }
    }

    function expandItem(item, content) {
        item.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';

        /* Recalculate after transitions / images load */
        setTimeout(function () {
            if (item.getAttribute('aria-expanded') === 'true') {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        }, 500);
    }

    function collapseItem(item, content) {
        item.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = '0px';
    }

    function handleHash(root) {
        var hash = window.location.hash.replace('#', '');
        if (!hash) return;

        var target = root.querySelector('[data-mb-policy-id="' + CSS.escape(hash) + '"]');
        if (!target) return;

        var content = target.querySelector(CONTENT_SELECTOR);
        if (content) {
            expandItem(target, content);
        }

        /* Scroll into view with offset for sticky header */
        setTimeout(function () {
            var headerOffset = getAnchorOffset(root);
            var rect = target.getBoundingClientRect();
            var scrollTop = window.pageYOffset + rect.top - headerOffset;
            window.scrollTo({ top: scrollTop, behavior: 'smooth' });

            /* Flash highlight */
            target.classList.add('mb-policies__item--highlight');
            setTimeout(function () {
                target.classList.remove('mb-policies__item--highlight');
            }, 2000);
        }, 150);
    }

    function getAnchorOffset(root) {
        var langList = root.querySelector(LANG_LIST_SELECTOR);
        var langListHeight = langList ? langList.getBoundingClientRect().height : 0;

        /* Add a small breathing room between sticky tabs and target row */
        return Math.ceil(langListHeight + 12);
    }

    function setActiveLang(root, lang) {
        /* Update buttons */
        root.querySelectorAll(LANG_BTN_SELECTOR).forEach(function (btn) {
            btn.classList.toggle('active', btn.getAttribute('data-mb-policy-lang') === lang);
        });

        /* Show/hide content blocks per language */
        root.querySelectorAll('[data-mb-policy-lang-content]').forEach(function (el) {
            var elLang = el.getAttribute('data-mb-policy-lang-content');
            el.style.display = elLang === lang ? '' : 'none';
        });

        /* Recalculate open accordion heights */
        root.querySelectorAll(ITEM_SELECTOR + '[aria-expanded="true"]').forEach(function (item) {
            var content = item.querySelector(CONTENT_SELECTOR);
            if (content) {
                content.style.maxHeight = content.scrollHeight + 'px';
                setTimeout(function () {
                    content.style.maxHeight = content.scrollHeight + 'px';
                }, 50);
            }
        });
    }

    /* ── Init ── */
    function init() {
        document.querySelectorAll(SECTION_SELECTOR).forEach(initPolicies);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    /* Re-init in Shopify theme editor */
    if (Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', init);
    }
})();
